import { Component, OnInit, ViewChildren } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AlertService, GrowlType } from '../../infrastructure/services/alert.service';
import { ItemLibraryService } from 'app/infrastructure/services/itemLibrary.service';
import { File64 } from '../../helpers/components/sxFileImport/file64.interf';
import { stringify } from '@angular/core/src/util';
import { ItemLibrary } from 'app/infrastructure/model/classes/itemLibrary.class';
import { Origen } from 'app/infrastructure/model/enum/origen.enum';

@Component({
  selector: 'item-library',
  templateUrl: 'item-library.component.html',
  styleUrls: ['./item-library.component.css'],
})

export class ItemLibraryComponent implements OnInit {
  systemCode: string;
  codlibrary: string;
  countries: string[] = [];
  insurances: any;
  itemLibrary: ItemLibrary = {
    category: '',
    country: '',
    id: '',
    description: '',
    title: '',
    origen: '',
    path: '',
    file64: null,
    insurance: '',
    extraInfo: '',
    status: 'P',
    type: 'Configuration',
  };

  supported: string[] = ['.xml'];

  file64: File64 = {
    fileData: '',
    fileName: '',
    extention: '',
  };
  file: string;
  origins: any = Object.keys(Origen);

  types = [
    'Product',
    'Template',
    'Configuration'
  ];

  constructor(private aRoute: ActivatedRoute,
    private router: Router,
    private itemLibraryService: ItemLibraryService,
    private alertService: AlertService) { }

  ngOnInit() {
    this.insurances = this.itemLibraryService.getInsurance();
    this.aRoute.params.subscribe((params: Params) => {
      this.codlibrary = params['codlibrary'];
      if (this.codlibrary !== 'nuevo') {
        this.getFiles();
      }
    });
  }

  uploadFile() {
    if (!this.file64) {
      this.alertService.showGrowl({
        type: GrowlType.DANGER,
        body: 'SOC_FE_0002_MUST_SELECT_A_FILE'
      });
      return;
    }

    if (!this.isXmlFile(this.itemLibrary.file64.extention)) {
      this.alertService.showGrowl({
        type: GrowlType.DANGER,
        body: 'SOC_FE_0006_FILE_MUST_BE_XLSX'
      });

      return;
    }

    this.itemLibraryService.saveOrEdit(this.itemLibrary).then(response => {
      this.file = null;
      this.getFiles();

      this.alertService.showGrowl({
        type: GrowlType.SUCCESS,
        body: 'SUCCESS_ITEM_LIBRARY_SAVE'
      });
    });
  }

  getFiles() {
    if (this.codlibrary !== 'nuevo') {
      this.itemLibraryService.getLibrary(this.codlibrary).subscribe(library => {
        const resp = JSON.parse(library.extraInfo);
        this.itemLibrary.country = resp.country;
        this.itemLibrary.origen = resp.origen;
        this.itemLibrary.category = resp.category;
        this.itemLibrary.description = resp.description;
        this.itemLibrary.insurance = resp.insurance;
        this.itemLibrary.id = this.codlibrary;
        this.itemLibrary.title = library.title;
        this.itemLibrary.type = library.type;
      });
    }
  }

  theFileChosen(imp: File64) {
    this.file64 = imp;
    this.file = imp.fileData;
  }

  isXmlFile(fileName: string): boolean {
    if (fileName.split('.').pop().replace(/^/, '.') === '.xml') {
      return true;
    }
    return false;
  }

  disableSave() {
    let disable = false;
    if (this.itemLibrary != null) {
      disable = this.file64.fileData === "";
    } else {
      disable = true;
    }
    return disable;
  }

  saveLibrary() {
    let extraInfo: any = {};
    extraInfo.country = this.itemLibrary.country;
    extraInfo.origen = this.itemLibrary.origen;
    extraInfo.category = this.itemLibrary.category;
    extraInfo.description = this.itemLibrary.description;
    extraInfo.insurance = this.itemLibrary.insurance;

    this.itemLibrary.extraInfo = JSON.stringify(extraInfo);
    this.itemLibrary.file64 = this.file64;
    this.itemLibraryService.saveOrEdit(this.itemLibrary).then(res => {
      this.alertService.showGrowl({
        type: GrowlType.SUCCESS,
        body: 'SUCCESS_ITEM_LIBRARY_SAVE'
      });
      this.back();
    });
  }

  deletFile(file: ItemLibrary) {
    this.itemLibraryService.Delete(this.codlibrary).subscribe(
      result => {
        let type = GrowlType.SUCCESS;
        let body = 'FILE_DELETED';

        if (!result) {
          type = GrowlType.DANGER;
          body = 'SOC_FE_0007_FILE_COULD_NOT_BE_DELETED';
        } else {
          this.getFiles();
        }
        return this.alertService.showGrowl({
          type: type,
          body: body,
        });
      });
  }

  back() {
    this.router.navigate(['..'], { relativeTo: this.aRoute });
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/item-library/item-library.component.ts